var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9995 0C46.5689 0 59.9995 13.4306 59.9995 30C59.9995 46.5694 46.5689 60 29.9995 60C13.4301 60 -0.000488281 46.5694 -0.000488281 30C-0.000488281 13.4306 13.4301 0 29.9995 0ZM29.9995 36.03C22.7358 36.03 12.2169 38.6456 11.8869 45.7481C14.138 48.3416 16.9206 50.4207 20.0457 51.8444C23.1708 53.2682 26.5654 54.0033 29.9995 54C37.2276 54 43.7094 50.805 48.1082 45.75L48.1064 45.6844C47.7276 38.7637 37.6345 36.1294 30.412 36.0319L29.9995 36.03ZM29.9995 14.88C28.8098 14.8795 27.6315 15.1135 26.5322 15.5685C25.4329 16.0235 24.434 16.6907 23.5927 17.5319C22.7513 18.3731 22.0839 19.3718 21.6286 20.471C21.1734 21.5702 20.9392 22.7484 20.9395 23.9381C20.939 25.1279 21.1729 26.3061 21.6279 27.4054C22.0829 28.5047 22.7501 29.5036 23.5913 30.3449C24.4325 31.1863 25.4314 31.8537 26.5306 32.3089C27.6298 32.7642 28.8079 32.9984 29.9977 32.9981C31.1876 32.9986 32.3658 32.7646 33.4652 32.3095C34.5647 31.8543 35.5638 31.187 36.4052 30.3456C37.2466 29.5042 37.9139 28.5053 38.369 27.4058C38.8242 26.3064 39.0582 25.128 39.0577 23.9381C39.058 22.7484 38.8236 21.5702 38.3683 20.471C37.9131 19.3718 37.2459 18.3731 36.4045 17.5319C35.5632 16.6907 34.5643 16.0235 33.465 15.5685C32.3657 15.1135 31.1893 14.8795 29.9995 14.88Z",
    fill: "url(#paint0_linear_93_244)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_244",
    x1: 3000,
    y1: 0,
    x2: 3000,
    y2: 6000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77818F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.dac8337ab63214bac5af0a1fa094989f.svg";
export { ForwardRef as ReactComponent };